import { NavigationEnd, Router } from '@angular/router';
import { Injectable } from '@angular/core';

@Injectable()
export class GoogleAnalyticsService {

  constructor(private router: Router) {
    router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        dataLayer.push({
          'event': 'Pageview',
          'pagePath': val.urlAfterRedirects
        });
      }
    });
  }
}